(function ($) {
    'use strict';

    var prfx = 'acom';

    acom_app.views.Search = Backbone.View.extend({
        el: '#acom-search',
        wrapper: '.cd-main-search',
        model: acom_app.models.settings,
        template: _.template($("#" + prfx + "-search-template").html()),
        initialize: function () {
            var _this = this
            this.helper = window.acom_app.models.helper
            this.settings = window.acom_app.models.settings
        },
        render: function () {
            this.close();
            this.bindEvents();

            var menu_slug = this.settings.get('content.search_menu_slug')
            var menus = this.helper.get('menus')

            var categories = this.helper.get('categories');
            var result = {
                menu_items: {},
                categories: {}
            };

            if (menu_slug && menus[menu_slug]) {
                var menu_items = menus[menu_slug].items
                if (menu_items.length > 0) {
                    _.each(menu_items, function (val, key) {
                        result['menu_items'][val.ID] = {
                            title: val.title,
                            url: val.url
                        };
                    });
                }
            }

            if (Object.keys(categories).length > 0) {
                _.each(categories, function (val, key) {
                    result['categories'][key] = val.name;
                });
            }

            result = _.extend({}, result, this.settings.toJSON());

            var html = this.template(result);
            $('#acom-search').append(html);
            this.delegateEvents();

            return this;
        },
        updateSearchFilter: function (e) {
            $('.cd-main-search').find('.selected-value').text($('.cd-main-search').find('option:selected').text());
        },
        closeByClick: function () {
            ACOM.navigationOpened = false;
            ACOM.closeSearchForm();
            ACOM.closeNavigation();
        },
        closeByKey: function () {
            if (event.which == '27') {
                ACOM.closeSearchForm();
            }
        },
        handleSubmit: function (e) {
            e.preventDefault();

            if (ACOM.mobile) return;
            if (!+this.settings.get('content.search_results')) return;

            var $input = $('[type="search"]', $('.cd-main-search'));
            var cat = $('[name="select-category"]', $('.cd-main-search')).val()
            var query = $input.val();

            if (cat != 'all') {
                cat = cat
            } else {
                cat = ''
            }

            $.ajax({
                url: window[prfx + '_localize']['ajaxurl'],
                type: 'post',
                data: {
                    action: prfx + '_search',
                    security: window[prfx + '_localize']['ajax_nonce'],
                    data: {
                        query: query,
                        cat: cat
                    }
                },
                success: function (data) {
                    window.acom_app.collections.results = new acom_app.collections.Results()
                    window.acom_app.collections.results.add(data);
                    var ResultsView = new Backbone.CollectionView({
                        el: $('#cd-search-results'),
                        class: 'active',
                        collection: acom_app.collections.results,
                        modelView: acom_app.views.Result,
                        clickToSelect: false
                    });
                    ResultsView.render();
                }
            })

        },
        rendered: function () {
            return $.contains(document, $('.cd-main-search').get(0));
        },
        bindEvents: function () {
            var _this = this
            $(document).on('click.acom', '.cd-main-search .close', this.closeByClick.bind(this))
            $(document).on('change.acom', '.cd-main-search select', this.updateSearchFilter.bind(this))
            $(document).on('submit.acom', '.cd-main-search form', function (e) {
                _this.handleSubmit(e)
            })
            $(document).on('keyup.acom', this.closeByKey.bind(this))
        },
        close: function () {
            $(this.wrapper).remove();

            $(document).off('click.acom', '.cd-main-search .close')
            $(document).off('change.acom', '.cd-main-search select')
            $(document).off('submit.acom', '.cd-main-search form')
            $(document).off('keyup.acom')
        }
    })
})(jQuery)